/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import {
  SCHOOLDATA_LOAD,
  SCHOOLDATA_LOAD_SUCCESS,
  SCHOOLDATA_LOAD_FAILURE,
} from "../../Constants/ActionTypes";
import { ISchoolData } from "../../Interfaces/SiteContent";

/**
 *
 */
export interface IGetSchools {
  type: typeof SCHOOLDATA_LOAD;
  countryRegionName: string;
}

/**
 *
 */
export interface IGetSchoolsSuccess {
  type: typeof SCHOOLDATA_LOAD_SUCCESS;
  schools: ISchoolData[];
}

/**
 *
 */
export interface IGetSchoolsFailure {
  type: typeof SCHOOLDATA_LOAD_FAILURE;
  schoolDataLoadError: string;
}

/**
 *
 * @param countryRegionName
 */
export const getSchoolData = (countryRegionName: string): SchoolActionTypes => ({
  type: SCHOOLDATA_LOAD,
  countryRegionName,
});

/**
 *
 * @param schoolData
 */
export const getSchoolDataSuccess = (schoolData: ISchoolData[]): SchoolActionTypes => ({
  type: SCHOOLDATA_LOAD_SUCCESS,
  schools: schoolData,
});

/**
 *
 * @param errorMessage
 */
export const getSchoolDataFailure = (schoolDataLoadError: string): SchoolActionTypes => ({
  type: SCHOOLDATA_LOAD_FAILURE,
  schoolDataLoadError,
});

export type SchoolActionTypes = IGetSchools | IGetSchoolsSuccess | IGetSchoolsFailure;
